import { formatIsoDate } from '@utils/utils-format'

import { trackEvent } from './track-event'

type Type = 'experience' | 'accommodation' | 'beach_chair' | 'search' | 'map' | 'rentable'

type Message =
  | 'success'
  | 'noRoomsAvailable'
  | 'minLengthOfStay'
  | 'maxLengthOfStay'
  | 'noBikesAvailable'
  | 'noStartDate'
  | 'no timeslots available - but others available'
  | 'no timeslots available'

type trackWebsiteMessagePayload = {
  action?: 'interaction - calendar' | 'EDP timeslots'
  from: Date | null | undefined
  to: Date | null | undefined
  adults?: number
  children?: number
  message?: Message
  messageArgs?: number | string
  selection?: string
}

export function trackWebsiteMessage(type: Type, payload: trackWebsiteMessagePayload) {
  const {
    from,
    to,
    adults,
    children,
    message = 'success',
    action = 'interaction - calendar',
  } = payload
  if (!from) return
  if (!to && type === 'accommodation') return

  const formatTo = to ? formatIsoDate(to) : null
  const selection = adults ? `${adults}xadults|${children || 0}xchildren` : payload.selection

  trackEvent({
    event: 'website_message',
    event_name: 'website_message',
    action,
    type,
    booking_period: `from ${formatIsoDate(from)} to ${formatTo}`,
    booking_period_from: formatIsoDate(from),
    booking_period_to: formatTo,
    selection,
    message: getMessage(message, payload.messageArgs),
  })
}

function getMessage(message?: Message, messageArgs?: number | string) {
  if (!message) return
  switch (message) {
    case 'minLengthOfStay':
      return `minLengthOfStay(${messageArgs})`
    case 'maxLengthOfStay':
      return `maxLengthOfStay(${messageArgs})`
    case 'success':
    case 'noRoomsAvailable':
    case 'noBikesAvailable':
    case 'noStartDate':
    case 'no timeslots available - but others available':
    case 'no timeslots available':
    default:
      return message
  }
}
